/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Empty_DescriptionInputs */

const es_settings_dirs_empty_description = /** @type {(inputs: Settings_Dirs_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las carpetas aparecerán aquí cuando ingieras directorios desde tus fuentes de almacenamiento.`)
};

const en_settings_dirs_empty_description = /** @type {(inputs: Settings_Dirs_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directories will appear here when you ingest folders from your storage sources.`)
};

/**
* | output |
* | --- |
* | "Directories will appear here when you ingest folders from your storage sources." |
*
* @param {Settings_Dirs_Empty_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_empty_description = /** @type {((inputs?: Settings_Dirs_Empty_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Empty_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_empty_description(inputs)
	return en_settings_dirs_empty_description(inputs)
});
export { settings_dirs_empty_description as "settings.dirs.empty.description" }